import { composer } from '../../../component-decorators/composer';
import { Tag } from 'wix-style-react';
import * as React from 'react';
import s from './category-header-mobile.scss';
export var SelectorTagMobile = composer()
    .withMarketplaceStore()
    .withTranslation()
    .compose(function (_a) {
    var name = _a.name, slug = _a.slug, t = _a.t;
    return (React.createElement(Tag, { className: name === t('category.filter-subcategory.all')
            ? s.selectorButtonAll
            : s.selectorButton, size: 'small', theme: 'light', dataHook: slug + "-selector-mobile", id: slug + "-selector-mobile", removable: false }, name));
});
//# sourceMappingURL=selector-tag-mobile.js.map